/**
 * District hosts (admin and parent) must not appear in search. Only the
 * marketing site is indexable. ATT-4349, ATT-4459.
 *
 * Sent as a response header and as a robots meta tag. Do not Disallow these
 * paths in robots.txt: a blocked URL can stay in the index from inbound
 * links, and Google then cannot see noindex.
 */

export const ROBOTS_DIRECTIVE = "noindex, nofollow";

export function searchIndexingHeaders() {
  const headers = [{ key: "X-Robots-Tag", value: ROBOTS_DIRECTIVE }];
  return [
    { source: "/", headers },
    { source: "/:path*", headers },
  ];
}
